<template>
  <div style="background: white">
    <prohead></prohead>
    <div class="banner" style="background: url('../../static/img/c_banner.png')">
      玩の国 乐の芯
    </div>
    <div class="banner_kai">
<!--      <div style="height: 50px;cursor: pointer" @click="fanhui()">-->
<!--        <img src="../../static/img/返回.png" alt="" style="display: block;float: left">-->
<!--        <div style="float:left;line-height: 25px;margin-left: 5px;">-->
<!--          返回列表-->
<!--        </div>-->
<!--      </div>-->
      <div class="baoxnav" >
        <div style="margin: 0 auto;width:800px" v-if="cur == '六大主题'">
          <div style="float:left;margin: 0 auto;position: relative" v-for="(m,index) in data" v-show="cur==m.cate_name" @click="clickshow(m.id)" :class="{active:curs==m.id}">
            <div>
              {{m.prd_name}}
            </div>
            <div style="position: absolute;left: 36%;" ><img src="../../static/img/jt.png" alt="" class="ac" :class="{actives:curs==m.id}" v-show="cur==m.cate_name" @click="clickshow(m.id)"></div>
          </div>
        </div>
        <div style="margin: 0 auto;width:1100px" v-if="cur == '十大项目'">
          <div style="float:left;margin: 0 auto;position: relative" v-for="(m,index) in data" v-show="cur==m.cate_name" @click="clickshow(m.id)" :class="{active:curs==m.id}">
            <div>
              {{m.prd_name}}
            </div>
            <div style="position: absolute;left: 36%;" ><img src="../../static/img/jt.png" alt="" class="ac" :class="{actives:curs==m.id}" v-show="cur==m.cate_name" @click="clickshow(m.id)"></div>
          </div>
        </div>
        <div style="margin: 0 auto;width:1200px" v-if="cur == '乐园图景'">
          <div style="float:left;margin: 0 auto;position: relative" v-for="(m,index) in data" v-show="cur==m.cate_name" @click="clickshow(m.id)" :class="{active:curs==m.id}">
            <div>
              {{m.prd_name}}
            </div>
            <div style="position: absolute;left: 36%;" ><img src="../../static/img/jt.png" alt="" class="ac" :class="{actives:curs==m.id}" v-show="cur==m.cate_name" @click="clickshow(m.id)"></div>
          </div>
        </div>
      </div>
      <div class="banner_new" style="padding-top: 40px;padding-bottom: 40px">
        <div v-html="detailsdata.content">
          {{detailsdata.content}}
        </div>
      </div>
    </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data() {
    return {
      data:[],
      detailsdata:'',
      url:'http://child.yohann.cn/',
      listQuery: {
        page: 1,
        limit: 100,
      },
      cur: '',
      curs:''
    }
  },
  created() {
    this.showPhoto()
    this.cur = this.$route.query.name
    this.curs = this.$route.query.id
    console.log(this.curs)
    this.details(this.curs)
  },
  mounted() {

  },
  methods: {
    clickshow(id){
      this.curs = id
      this.details(id)
    },
    showPhoto(){
      let formdata = new FormData()
      formdata.append('page',this.listQuery.page)
      formdata.append('limit',this.listQuery.limit)

      this.$axios.post('/index/Product/ProductList  ',formdata).then(res => {
        this.data = res.data.data
      });
    },
    fanhui(){
      this.$router.go(-1)
    },
    details(id){
      console.log(this.$route.query.id)
      let formdata = new FormData()
      formdata.append('id',id)
      this.$axios.post('/index/Product/productDetail',formdata).then(res => {
        this.detailsdata= res.data.data
      });
    },
  }
}
</script>

<style scoped>
.baoxnav{
  margin-top: 40px;
  width: 1300px;
  height: 46px;
  background: #F6F6F6;

}
.baoxnav div{
  //width: 120px;
  height: 46px;
  padding: 0 10px;
  //background: #EA5C48;
  text-align: center;
  line-height: 46px;
}
.baoxnav div:hover{
  cursor: pointer;

}
.ac{
  display: none
}
.actives{
  display: block;
}
.active{
  background: #EA5C48;
  color: white;
  cursor: pointer;

}
.depict{
  height:46px ;
  width: 900px;
  margin-top: 10px;
  font-size: 16px;

}
.new-title .time{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
  margin-top: 10px;
  display: block;
  width: 900px;
  height: 30px;

}

.new_img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
  margin-right: 30px;
}
.new_img img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
}
.banner_new li{
  width: 1300px;
  height: 220px;
}
.banner_new li div{
  float: left;
}
.banner_pin div{
  float: left;
}
.box3{
  margin: 0 auto;
  width: 1920px;
  height: 618px;
//background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/prodetails.vue